export default __webpack_public_path__ + "static/media/android_icon.cce25636.svg";